export const roundNumbers = value => {
  const isNum = /^-?\d+\.\d+$/.test(value);
  if(!isNum) return value
  return parseFloat(value).toFixed(3)
}